import { api, ApiRes } from './_api-client';
import { AccessType } from './access.service';
import { FolderQueryParams } from './folders.service';
import { UserRole } from './share.service';

export enum ProjectStatus {
  'Empty',
  'Uploading',
  'Processing',
  'Processed',
}

export interface Project {
  projectId: ProjectId;
  folderId: FolderId | null;
  name: string;
  status: number;
  size: number;
  createdAt: string;
  accessedAt: string | null;
  updatedAt: string | null;
  ownerName: string | null;
  ownerId: number;
  role: UserRole;
  accessType: AccessType;
}

export interface SetAccessedAtRes extends ApiRes {
  data: string;
}

export interface UpdateEntity {
  name: string;
  id: number;
}

export interface UpdateObjectResult extends ApiRes {
  url: string | null;
}

export interface CreateProject {
  projectName: string;
  folderId?: FolderId;
}

/* S E R V I C E */

export const createProject = ({ projectName, folderId }: CreateProject) => {
  return api.post<ApiRes>(`/Project/CreateProject`, { projectName, folderId });
};

export const removeProject = (projectId: ProjectId) => {
  return api.delete<ApiRes>(`/Project/removeProject?projectId=${projectId}`);
};

export const updateProject = (payload: UpdateEntity) => {
  return api.patch<UpdateObjectResult>('/Project/updateProject', { projectName: payload.name, projectId: payload.id });
};

export const getUserProjects = ({ folderId, allActive }: FolderQueryParams) => {
  const params = new URLSearchParams();
  if (folderId !== undefined) params.append('folderId', String(folderId));
  if (allActive !== undefined) params.append('allActive', String(allActive));
  return api.get<Project[]>(`/Project/GetUserProjects?${params.toString()}`);
};

export const setProjectAccessedAt = (projectId: ProjectId) => {
  return api.patch<SetAccessedAtRes>(`/Project/SetProjectAccessedAt?projectId=${projectId}`);
};
